import _defineProperty from "/Users/matt/dev/github.com/industriousapps/excelkits-client/node_modules/.pnpm/next@13.5.7_@babel+core@7.25.2_react-dom@18.3.1_react@18.3.1__react@18.3.1_sass@1.79.3/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import clsx from 'clsx';
import merge from 'lodash/merge';
import { useCallback, useMemo } from 'react';
import { FilterBase } from '@/utils/widget/createSelections/interfaces';
import { deleteUndefinedValues } from '@/utils/objects';
import { getResultExampleValue } from '@/components/Editor/Form/utils';
import useSelections from '@/components/widget/misc/useSelections';
import useSubscribeWidgetResults from '@/components/widget/visualizations/hooks/useSubscribeWidgetResults';
import { AxisFields } from '@/components/Editor/Form/fields/ChartJsAxes';
import styles from './styles.module.scss';
import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const DEFAULT_SELECTION_CONFIG = {
  base: FilterBase.Pairs
};

const EditChartAxes = _ref => {
  let {
    widgetId,
    sectionId,
    reportingWidgetId,
    axis,
    config,
    variant,
    onChange
  } = _ref;
  const nameSpace = `${widgetId}-${sectionId}-${axis}`;
  const {
    globalSeriesOptions
  } = config; // Get current selection results

  const results = useSubscribeWidgetResults(reportingWidgetId); // Apply selections to results

  const {
    selectionResults
  } = useSelections({
    results: results,
    selections: config.selections || '',
    selectionsLabeled: false,
    selectionConfig: DEFAULT_SELECTION_CONFIG
  }); // Defaults to integer as example
  // value for template authoring

  const exampleValue = useMemo(() => getResultExampleValue({
    collectionIndex: 0,
    selectionIndex: 0,
    valueIndex: 1,
    spreadsheetSelections: selectionResults,
    fallback: 10
  }), [selectionResults]);
  const handleChange = useCallback(function (update) {
    let attr = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
    const axisValues = axis === 'x' ? {
      xAxisTitle: update.axisTitle,
      xAxisTemplate: update.axisTemplate
    } : {
      yAxisTitle: update.axisTitle,
      yAxisTemplate: update.axisTemplate
    };
    onChange(attr, merge({}, deleteUndefinedValues(axisValues)));
  }, [axis, onChange]);
  if (!axis) return null;
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsxs("div", {
      className: clsx(styles.heading, styles[`heading--${variant}`]),
      children: [axis.toUpperCase(), " Axis"]
    }), /*#__PURE__*/_jsx("div", {
      className: clsx(styles.content, styles[`content--${variant}`]),
      children: /*#__PURE__*/_jsx(AxisFields, _objectSpread(_objectSpread({
        nameSpace: nameSpace,
        exampleValue: exampleValue,
        defaultTemplate: globalSeriesOptions === null || globalSeriesOptions === void 0 ? void 0 : globalSeriesOptions.template
      }, getAxisProps(config, axis)), {}, {
        onChange: handleChange
      }), nameSpace)
    })]
  });
};

function getAxisProps(config, axis) {
  const isXAxis = axis === 'x';
  return {
    axisTitle: isXAxis ? config.xAxisTitle : config.yAxisTitle,
    axisTemplate: isXAxis ? config.xAxisTemplate : config.yAxisTemplate
  };
}

export default EditChartAxes;